export default __webpack_public_path__ + "static/media/logo-banner.1baac073.png";